module.exports = __webpack_public_path__ + "img/123.75bd6f07.jpg";